
import Dot from '@/components/UntitledUI/Dot.vue'
import Icon from '@/components/UntitledUI/Icon.vue'

export default {
    name: 'CategoryItem',
    components: { Dot, Icon },
    props: {
        categoryItem: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        path () {
            return (this.categoryItem.type === 'file' ? '/File/' : '/Contract-Template/') + this.categoryItem.id
        }
    },
    methods: {
        formatDate (date) {
            const locale = `${this.$i18n.locale}-US`
            return new Date(date).toLocaleDateString(locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            })
        }
    }
}
